 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		46: 0
 	};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		46: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "app." + ({"8":"DeprecatedStyles","11":"EnhancedStyles","12":"app-components-Workflow-WorkflowContainer","13":"app-components-bibs-BibPage-BibPageContainer","14":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","15":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","16":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","17":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","18":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","19":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","20":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","21":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","22":"app-components-bibs-subpages-CommentPage-CommentPageContainer","23":"app-components-bibs-subpages-MarcPage-MarcPageContainer","24":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","25":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","26":"app-components-bibs-subpages-VideoPage-VideoPageContainer","27":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","28":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","29":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","30":"app-components-borrowing-fines-Fines-FinesContainer","31":"app-components-borrowing-holds-Holds-HoldsContainer","32":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","33":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","34":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","35":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","36":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","37":"app-components-events-EventsSearchPage-EventsSearchPageContainer","38":"app-components-events-MyEventsPage-MyEventsPageContainer","39":"app-components-locations-LocationsPage-LocationsPage","40":"app-components-search-Search-SearchContainer","41":"app-components-search-SearchPrintList-SearchPrintListContainer","42":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","43":"app-components-shelves-Shelf-ShelfContainer","44":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","45":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"684ef7c4406e06c5512c","1":"2e23c0e95cae70009a46","2":"ee5f1ac34c05bc33af12","3":"97d2a5d21bec96d7236d","4":"228782e0f913648f993c","5":"01033d0b1f6442a00e6b","6":"5bc0d3f080bddc77ec40","7":"076f521039e8f1615a58","8":"be763441b2b91fe06a0c","9":"2dc95c160f29d10aed01","10":"cc84a36ca803c0057890","11":"bd061fb92dfe6dd2a812","12":"424be884530688bd4612","13":"eb7c71d810cff7c389a8","14":"ab2e9dc63090e3335577","15":"6c47d46c0930340d4cfe","16":"53b39525883b50bfd628","17":"36731ee16715f76efa1a","18":"a946227443f184187f39","19":"62c38094a57dee697f7d","20":"101c382a2cda9e593d9d","21":"b1f5b3161f49cbbaf93f","22":"cd6b6450ad220a9195fb","23":"0abfbcdbcd7e6d3ca5f9","24":"3e0470c28f87d507021b","25":"5930c7c2d0f86d967303","26":"ce4b57ad36ecde928384","27":"9693ad1db37dfe5c8d6a","28":"cce01107b3ed36f0303c","29":"46c2a3579e012277bdba","30":"7d8f6fbc15d926654a88","31":"81607008bb991cb1344b","32":"949994ce82209be943c6","33":"91722d5e8a32806bb580","34":"2f20872554885b2da136","35":"d9cb239b9f898154a0a2","36":"8134fe1c3fd357acda9e","37":"17d4cb6cecefc21c860d","38":"792ea5fac42dff51b403","39":"8b87c47289b050bdaeab","40":"bb9a889cd4e45218465c","41":"8d00b94cde4d431a23ed","42":"3b8ee7dd7322d908f4a5","43":"8fbe8552d1bd98db9ddf","44":"83dea4f5c882af2eac24","45":"fe766470d2f6976a0a70","47":"c3fec2364122d4045063","48":"95da3adcd372a1ef3d3a","49":"cf96a7c27b2d51c00491","50":"2b4027b8c88bfd6b628f","51":"81cbb497592088f8205a","52":"037ead7f842c1c10267a","53":"7d0600db3466488a78cc","54":"e57dcea76f9912528905"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1,"1":1,"2":1,"3":1,"4":1,"5":1,"6":1,"7":1,"8":1,"9":1,"10":1,"11":1,"12":1,"13":1,"14":1,"15":1,"16":1,"17":1,"18":1,"19":1,"20":1,"21":1,"22":1,"23":1,"24":1,"25":1,"26":1,"27":1,"28":1,"29":1,"30":1,"31":1,"32":1,"33":1,"34":1,"35":1,"36":1,"37":1,"38":1,"39":1,"40":1,"41":1,"42":1,"43":1,"44":1,"45":1,"47":1,"48":1,"49":1,"50":1,"51":1,"52":1,"53":1,"54":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "app." + ({"8":"DeprecatedStyles","11":"EnhancedStyles","12":"app-components-Workflow-WorkflowContainer","13":"app-components-bibs-BibPage-BibPageContainer","14":"app-components-bibs-subpages-AllCommentsPage-AllCommentsPageContainer","15":"app-components-bibs-subpages-AllContentNoticesPage-AllContentNoticesPageContainer","16":"app-components-bibs-subpages-AllListsPage-AllListsPageContainer","17":"app-components-bibs-subpages-AllQuotationsPage-AllQuotationsPageContainer","18":"app-components-bibs-subpages-AllRecommendationsPage-AllRecommendationsPageContainer","19":"app-components-bibs-subpages-AllReviewsPage-AllReviewsPageContainer","20":"app-components-bibs-subpages-AllSummariesPage-AllSummariesPageContainer","21":"app-components-bibs-subpages-AllVideosPage-AllVideosPageContainer","22":"app-components-bibs-subpages-CommentPage-CommentPageContainer","23":"app-components-bibs-subpages-MarcPage-MarcPageContainer","24":"app-components-bibs-subpages-QuotationPage-QuotationPageContainer","25":"app-components-bibs-subpages-SummaryPage-SummaryPageContainer","26":"app-components-bibs-subpages-VideoPage-VideoPageContainer","27":"app-components-borrowing-accountmessages-AccountMessages-AccountMessagesContainer","28":"app-components-borrowing-checkouts-CheckedOut-CheckedOutContainer","29":"app-components-borrowing-checkouts-CheckedOutPrintList-CheckedOutPrintListContainer","30":"app-components-borrowing-fines-Fines-FinesContainer","31":"app-components-borrowing-holds-Holds-HoldsContainer","32":"app-components-borrowing-holds-HoldsPrintList-HoldsPrintListContainer","33":"app-components-borrowing-interlibraryLoans-InterlibraryLoans-InterlibraryLoansContainer","34":"app-components-borrowing-interlibraryLoans-InterlibraryLoansPrintList-InterlibraryLoansPrintListContainer","35":"app-components-borrowing-recentlyreturned-RecentlyReturned-RecentlyReturnedContainer","36":"app-components-borrowing-recentlyreturned-RecentlyReturnedPrintList-RecentlyReturnedPrintListContainer","37":"app-components-events-EventsSearchPage-EventsSearchPageContainer","38":"app-components-events-MyEventsPage-MyEventsPageContainer","39":"app-components-locations-LocationsPage-LocationsPage","40":"app-components-search-Search-SearchContainer","41":"app-components-search-SearchPrintList-SearchPrintListContainer","42":"app-components-shared-AvailabilityDetailOverlay-AvailabilityDetailOverlayContainer","43":"app-components-shelves-Shelf-ShelfContainer","44":"app-components-shelves-ShelfPrintList-ShelfPrintListContainer","45":"app-components-widgets-WidgetsPage-WidgetsPageContainer"}[chunkId]||chunkId) + "-" + {"0":"684ef7c4406e06c5512c","1":"2e23c0e95cae70009a46","2":"ee5f1ac34c05bc33af12","3":"97d2a5d21bec96d7236d","4":"228782e0f913648f993c","5":"01033d0b1f6442a00e6b","6":"5bc0d3f080bddc77ec40","7":"076f521039e8f1615a58","8":"be763441b2b91fe06a0c","9":"2dc95c160f29d10aed01","10":"cc84a36ca803c0057890","11":"bd061fb92dfe6dd2a812","12":"424be884530688bd4612","13":"eb7c71d810cff7c389a8","14":"ab2e9dc63090e3335577","15":"6c47d46c0930340d4cfe","16":"53b39525883b50bfd628","17":"36731ee16715f76efa1a","18":"a946227443f184187f39","19":"62c38094a57dee697f7d","20":"101c382a2cda9e593d9d","21":"b1f5b3161f49cbbaf93f","22":"cd6b6450ad220a9195fb","23":"0abfbcdbcd7e6d3ca5f9","24":"3e0470c28f87d507021b","25":"5930c7c2d0f86d967303","26":"ce4b57ad36ecde928384","27":"9693ad1db37dfe5c8d6a","28":"cce01107b3ed36f0303c","29":"46c2a3579e012277bdba","30":"7d8f6fbc15d926654a88","31":"81607008bb991cb1344b","32":"949994ce82209be943c6","33":"91722d5e8a32806bb580","34":"2f20872554885b2da136","35":"d9cb239b9f898154a0a2","36":"8134fe1c3fd357acda9e","37":"17d4cb6cecefc21c860d","38":"792ea5fac42dff51b403","39":"8b87c47289b050bdaeab","40":"bb9a889cd4e45218465c","41":"8d00b94cde4d431a23ed","42":"3b8ee7dd7322d908f4a5","43":"8fbe8552d1bd98db9ddf","44":"83dea4f5c882af2eac24","45":"fe766470d2f6976a0a70","47":"c3fec2364122d4045063","48":"95da3adcd372a1ef3d3a","49":"cf96a7c27b2d51c00491","50":"2b4027b8c88bfd6b628f","51":"81cbb497592088f8205a","52":"037ead7f842c1c10267a","53":"7d0600db3466488a78cc","54":"e57dcea76f9912528905"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");

 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				var onLinkComplete = function (event) {
 					// avoid mem leaks.
 					linkTag.onerror = linkTag.onload = null;
 					if (event.type === 'load') {
 						resolve();
 					} else {
 						var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 						var realHref = event && event.target && event.target.href || fullhref;
 						var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + realHref + ")");
 						err.code = "CSS_CHUNK_LOAD_FAILED";
 						err.type = errorType;
 						err.request = realHref;
 						delete installedCssChunks[chunkId]
 						linkTag.parentNode.removeChild(linkTag)
 						reject(err);
 					}
 				};
 				linkTag.onerror = linkTag.onload = onLinkComplete;
 				linkTag.href = fullhref;

 				document.head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn-nerf.bibliocommons.com/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["__LOADABLE_LOADED_CHUNKS__"] = window["__LOADABLE_LOADED_CHUNKS__"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2326);
